__turbopack_context__.v({
  "block": "Copyright-module-scss-module__ClYW0G__block",
  "hidden": "Copyright-module-scss-module__ClYW0G__hidden",
  "line-break": "Copyright-module-scss-module__ClYW0G__line-break",
  "text": "Copyright-module-scss-module__ClYW0G__text",
  "text-align_center": "Copyright-module-scss-module__ClYW0G__text-align_center",
});
